var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavListPeopleGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55789 11.5882H2.38947C2.02096 11.5882 1.66754 11.4395 1.40697 11.1747C1.14639 10.91 1 10.5509 1 10.1765V2.41176C1 2.03734 1.14639 1.67825 1.40697 1.4135C1.66754 1.14874 2.02096 1 2.38947 1H5.16842L7.25263 3.11765H12.1158C12.4843 3.11765 12.8377 3.26639 13.0983 3.53114C13.3589 3.7959 13.5053 4.15499 13.5053 4.52941V7.35294M12.8105 13L14.2 11.5882L12.8105 10.1765M10.7263 10.1765L9.33684 11.5882L10.7263 13",
    stroke: "#9FA09F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavListPeopleGrey);
export default __webpack_public_path__ + "static/media/FavListPeopleGrey.f74da55fcb69a9372ccfecbee96da383.svg";
export { ForwardRef as ReactComponent };